import { render } from "./LinkModal.vue?vue&type=template&id=6bf26524&scoped=true"
import script from "./LinkModal.vue?vue&type=script&lang=js"
export * from "./LinkModal.vue?vue&type=script&lang=js"

import "./LinkModal.vue?vue&type=style&index=0&id=6bf26524&scoped=true&lang=css"

import exportComponent from "/Users/iyongmin/Documents/twin-cosmos/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf26524"]])

export default __exports__